module.exports = __webpack_public_path__ + "static/media/profile-frame-right.48dc43e7.svg";